<viz-header title="Enterprise Cross-Reference Consumption" brandLink="https://www.vizientinc.com/" svgIcon="">
  <viz-nav-menu *ngIf="isAuthenticated" icon="help">
    <viz-nav-menu-item link="{{releaseNotesUrl}}" displayText="What's New"></viz-nav-menu-item>
  </viz-nav-menu>
  <viz-nav-menu icon="apps">
    <viz-nav-menu-item link="https://learning.vizientinc.com/Enterprise_Cross_Reference_Consumption_Portal/Pages/default.aspx"
                       displayText="User Guide">
    </viz-nav-menu-item>
  </viz-nav-menu>
  <viz-nav-menu icon="person" *ngIf="isAuthenticated">
    <viz-nav-menu-item *ngIf="isAuthenticated && isAdmin" userName="{{userName}} : Admin"></viz-nav-menu-item>
    <viz-nav-menu-item *ngIf="isAuthenticated && !isAdmin" userName="{{userName}}"></viz-nav-menu-item>
    <viz-nav-menu-item *ngIf="isAuthenticated" (click)="logout()" displayText="Log Out"></viz-nav-menu-item>
  </viz-nav-menu>
  <mat-toolbar *ngIf="!isAuthenticated">
    <button mat-button (click)="login()">
      <span class="menu-item-css">
        Login
      </span>
    </button>
  </mat-toolbar>
</viz-header>

